module.exports = "<a mat-icon-button (click)=\"back()\" matTooltip=\"Atrás\"><mat-icon>arrow_back</mat-icon></a>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/back-button/back-button.component.html
// module id = ./src/app/shared-components/back-button/back-button.component.html
// module chunks = main